export default __webpack_public_path__ + "static/media/ico-alert-success.27b08170.svg";